import Head from 'next/head';
import { useRouter } from 'next/router';
import { CSSProperties, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from 'contexts/AuthContext';
import { EnvVars } from 'env';
import { NavItems } from 'types';
import Container from './Container';
import Footer from './Footer';
import Navbar from './Navbar';
import SecondNavbar from './SecondNavbar';

export interface PageProps {
  title?: string;
  image?: string;
  description?: string;
  margin?: boolean;
  navbar?: boolean;
  isPublicPage?: boolean;
  containerStyles?: CSSProperties;
  childrenWrapperStyles?: CSSProperties;
}

export default function Page({
  title,
  image,
  description,
  margin,
  children,
  navbar,
  isPublicPage = false,
  containerStyles,
  childrenWrapperStyles,
}: PropsWithChildren<PageProps>) {
  const { user } = useAuth();
  const { pathname } = useRouter();
  const [enfeite, setEnfeite] = useState<StaticImageData[]>([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showSecondNavBar, setShowSecondNavBar] = useState(false);
  const pagesPublic = useMemo(() => {
    return [
      '/pricing',
      '/contact',
      '/cookies-policy',
      '/features',
      '/privacy-policy',
      '/reset-password',
      '/change-password',
      '/faq',
      '/about',
      '/blog',
      '/instrucoes-formulario-recebimento',
    ];
  }, []);

  const navItems: NavItems = [

    { title: 'Criar campanha', href: !isAuthenticated ? '/login' : '/profile/user', outlined: true },
  ];

  useEffect(() => {
    setIsAuthenticated(!!user?.email);
    setShowSecondNavBar(!pagesPublic.includes(pathname));
  }, [isAuthenticated, pagesPublic, pathname, user]);


  return (
    <>
      {title && (
        <Head>
          <title>
            {title} | {EnvVars.SITE_NAME}
          </title>
          <meta name="description" content={description} />
          {image && <meta name="image" content={image} />}
        </Head>
      )}
      <Wrapper>
        {(!isAuthenticated || isPublicPage) && <Navbar items={navItems} />}
        {isAuthenticated && !isPublicPage && (
          <>
            <Navbar items={undefined} />
            {!showSecondNavBar && <SecondNavbar />}
          </>
        )}

        {enfeite?.map((i, index) => (
          <>
            <img src={i.src} key={index} className={`img-${index}`} alt="Enfeite" />
          </>
        ))}
        <Container style={containerStyles}>
          <ChildrenWrapper style={childrenWrapperStyles} margin={margin}>
            {children}
          </ChildrenWrapper>
        </Container>
        <Footer />
      </Wrapper>
    </>
  );
}

interface ITemaProps {
  temaEvento: string;
}

const Wrapper = styled.div`
  background-repeat: no-repeat;
  object-fit: contain;
  background: #FBF9ED;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > img {
    position: absolute;
  }

  > .img-0 {
    top: 260px;
    z-index: 9999;
    width: 200px;
  }

  > .img-1 {
    right: 0;
    z-index: 9999;
    width: 200px;
    top: 260px;
  }

  > .img-2 {
    width: 200px;
    top: 1500px;
  }

  > .img-3 {
    right: 0;
    width: 200px;
    top: 1500px;
  }
`;

interface IMarginProps {
  margin?: boolean;
}

const ChildrenWrapper = styled.div<IMarginProps>`
  margin-top: ${({ margin }) => (margin ? 10 : 0)}rem;
  margin-bottom: 10rem;
`;
